// #139 Next Day Openings Dashboard — gate predicate for the new "openings"
// dashboard button alongside Help and Time Machine.
//
// Returns true ONLY when the user is logged in AND their Users document
// carries `dashboardAccess: true` (strict equality — undefined, null,
// false, or any other truthy non-true value all hide the button).
//
// Why strict `=== true`:
//   - The seed migration (dbtools/src/mutations/users-add-dashboardAccess-and-locations.mjs)
//     stamps `false` on every Users doc. Admins flip selected users to `true`
//     in MongoDB Compass to grant access.
//   - Treating any-truthy as access would mean a future schema change that
//     stores e.g. a permission level string ("read", "admin") accidentally
//     opens the gate. Strict-true documents the intent.
//
// Why `dashboard*` field naming (generic) instead of `nextDayOpenings*`:
//   The flag is intended to gate ALL future dashboard variants (capacity
//   overviews, late-jobs reports, etc.), not just the #139 next-day-openings
//   view. Same gate, same persisted location selection.

export function canAccessDashboard(mongoUser, tsUserDocument) {
  return Boolean(mongoUser) && tsUserDocument?.dashboardAccess === true;
}
